const userObjectState = {};

export default (state = userObjectState, action) => {
  switch (action.type) {
    case 'USER_STORE':
      return {
        ...state,
        ...action.user
      };
    case 'USER_UPDATE':
      return {
        ...state,
        ...action.user
      };
    case 'USER_DELETE':
      return {};
    default:
      return state;
  }
};
